'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { APPROVED_APPS } from '@sola/auth-sdk/apps.ts';
import { AuthStatusEnum, useAuth } from '@sola/auth-sdk/store.tsx';
import { getPublicConfig } from '@sola/config/lib/getters.ts';
import { AuthSearchParam } from '@sola/schema/dotcom/auth/routes.ts';
import { MOCK_SUPPORTER } from '@sola/supporter-sdk/constants.ts';
import { stripCurrentQueryParam } from '../../utils/browser.ts';
export const useVolunteerLocationTemplate = pathname => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getPublicConfig();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    NEXT_PUBLIC_BASE_URL_AUTH,
    NEXT_PUBLIC_BASE_URL_DOTCOM
  } = t0;
  const {
    currentStatus,
    isReady
  } = useAuth("currentStatus", "isReady");
  const searchParams = useSearchParams();
  const t1 = `${NEXT_PUBLIC_BASE_URL_DOTCOM}${pathname}?action=register`;
  let t2;
  if ($[1] !== t1) {
    t2 = new URLSearchParams({
      [AuthSearchParam.App]: APPROVED_APPS.volunteer.key,
      [AuthSearchParam.Redirect]: t1
    });
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const loginSearchParams = t2;
  const loginUrl = `${NEXT_PUBLIC_BASE_URL_AUTH}/?${loginSearchParams}`;
  const isLoggedIn = !!MOCK_SUPPORTER || currentStatus === AuthStatusEnum.Authenticated;
  let t3;
  if ($[3] !== searchParams) {
    t3 = searchParams?.get("action");
    $[3] = searchParams;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const hasActionParam = t3 === "register";
  const shouldAutoOpen = isReady && isLoggedIn && hasActionParam;
  const hasCleanedUrl = useRef(false);
  let t4;
  let t5;
  if ($[5] !== shouldAutoOpen) {
    t4 = () => {
      if (!shouldAutoOpen || hasCleanedUrl.current) {
        return;
      }
      hasCleanedUrl.current = true;
      stripCurrentQueryParam("action");
    };
    t5 = [shouldAutoOpen];
    $[5] = shouldAutoOpen;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== isLoggedIn || $[9] !== loginUrl || $[10] !== shouldAutoOpen) {
    t6 = {
      isLoggedIn,
      shouldAutoOpen,
      loginUrl
    };
    $[8] = isLoggedIn;
    $[9] = loginUrl;
    $[10] = shouldAutoOpen;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};